import UserAvatar from "../../../components/UserAvatar";
import { Link } from "react-router-dom";
import { usePreserveQueryParams } from "../../../utilites/usePersistQuery";

const OnExitModalContent = ({ popupData }) => {
  const { withQuery } = usePreserveQueryParams();

  return (
    <>
      <div className="text-center">
        <UserAvatar
          avatar={popupData?.randomTaxPro?.user?.avatar}
          alt={`${popupData?.randomTaxPro?.user?.firstname} ${popupData?.randomTaxPro?.user?.lastname}`}
          className="img-fluid rounded-circle h-100"
          style={{ width: "130px" }}
        />
      </div>

      <div className="text-center px-5 d-flex justify-content-center mt-3">
        <p
          className="mb-0 text-black"
          style={{ fontSize: "16px", maxWidth: "350px" }}
        >
          Hi, I’m{" "}
          <strong>
            {popupData?.randomTaxPro?.user?.firstname +
              " " +
              popupData?.randomTaxPro?.user?.lastname}
          </strong>
          , one of the more than{" "}
          <strong>{popupData?.taxProCount} Tax Professionals</strong> here at{" "}
          <strong>Uncle Kam</strong>. Schedule an appointment with me by
          answering a few basic questions about your finances. I promise, you
          won’t regret it.
        </p>
      </div>

      <div className="mt-4 d-flex justify-content-end bg-primary">
        <Link
          className="btn text-white rounded-0"
          style={{ backgroundColor: "#3C3BEA" }}
          to={process.env.REACT_APP_ENV === 'production' ? withQuery(
            `/register?pro_id=${popupData?.randomTaxPro?.uuid}`
          ) : withQuery(
            `/walkthrough?pro_id=${popupData?.randomTaxPro?.uuid}`
          )}
          onClick={() => {
            localStorage.removeItem('assesment')
            localStorage.removeItem('walthroughStep')
            document.querySelector(".onExitPopup")?.click();
          }}
        >
          Get Started
        </Link>
      </div>
    </>
  );
};

export default OnExitModalContent;
